import {createSelector} from "@reduxjs/toolkit";
import {FinancialInstitutionState} from "types/financialInstitutionState";
import {State} from "types/store";
import {EntityState} from "types/enums/entityState";

export const get = (rootState: State): FinancialInstitutionState => rootState.financialInstitution;

export const getAppAssociatedFinancialInstitution = createSelector(get, (state) => {
  return state?.appAssociated;
});

export const getIsFinancialInstitutionInactive = createSelector(
  getAppAssociatedFinancialInstitution,
  (appAssociated) => {
    return appAssociated
      ? appAssociated.state === EntityState.ARCHIVED || appAssociated.state === EntityState.DELETED
      : false;
  }
);
